export const Selection = {
    get: () => getSelection(),

    clearSelection: () => Selection.get()?.empty(),

    isNodeSelectable: (node: Node | null) => {
        if (!node) {
            return false
        }
        const style = getComputedStyle(node as Element)

        return style.userSelect !== 'none' && style.display !== 'none' && style.visibility !== 'hidden'
    },

    extractTextInRange: (textNode: Node, range: Range) => {
        const text = textNode.nodeValue

        let start = 0
        let end = text?.length

        if (textNode === range.startContainer) {
            start = range.startOffset
        }
        if (textNode === range.endContainer) {
            end = range.endOffset
        }

        return text?.slice(start, end)
    },

    extractSelectableText: (node: Node, range: Range) => {
        if (node.nodeType === Node.TEXT_NODE && Selection.isNodeSelectable(node.parentNode)) {
            return Selection.extractTextInRange(node, range)
        }

        let result = ''

        node.childNodes.forEach((child) => {
            if (!range.intersectsNode(child)) {
                return
            }
            if (child.nodeType === Node.TEXT_NODE && Selection.isNodeSelectable(child.parentNode)) {
                result += Selection.extractTextInRange(child, range)
            } else if (child.nodeType === Node.ELEMENT_NODE && Selection.isNodeSelectable(child)) {
                result += Selection.extractSelectableText(child, range)
            }
        })

        return result
    },

    getSelectableText: (selection: Selection | null) => {
        if (!selection) return ''

        let text = ''

        for (let i = 0; i < selection.rangeCount; i++) {
            const range = selection.getRangeAt(i)
            text += Selection.extractSelectableText(range.commonAncestorContainer, range)
        }

        return text.trim()
    },
}
